import React, { FC } from 'react';
import { decimal2Percentile } from '@/infrastructure/utils/to-unit';
import style from './index.module.scss';

interface IProps {
  name: string;
  info?: string;
}

export const getTopInfo = (
  total: number,
  topNum: number,
  coverageRate: number,
  filter: boolean,
  isCompareOpen?: boolean,
) => {
  if (total === 0 || total < topNum || isCompareOpen) {
    return `满足条件的问题共${total}个`;
  }
  return (filter
    ? `满足条件的问题共${total}个，当前显示上报量Top${!!Number(topNum) ? topNum : total}的问题，包含${decimal2Percentile(coverageRate, 2)}的上报个例`
    : `满足条件的问题共${total}个，上报量Top${!!Number(topNum) ? topNum : total}的问题包含${decimal2Percentile(coverageRate, 2)}的上报个例`);
};

export const IssuesListHeader: FC<IProps> = props => (
  <div className={style.issueListHeaderLayout}>
    <div>
      <span className={style.name}>
        {props.name}
      </span>
      <span className={style.info}>
        {props.info}
      </span>
    </div>
  </div>
);
